import { createSlice } from "@reduxjs/toolkit";
import { AddColor, UpdateColor, GetColorList } from "services/other/color.service";
import { toast } from 'react-toastify';

export const colorAddSlice = createSlice({
  name: "colorAdd",
  initialState: {
    colorAdd: {},
    colorAddLoading: false,
    colorAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddColor.pending, (state) => {
      // toast.loading('We are adding the color 🤯')
      state.colorAddLoading = true
    });

    builder.addCase(AddColor.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New color added successfully 👌');

      state.colorAdd = action.payload
      state.colorAddLoading = false
      state.colorAddError = null
    });

    builder.addCase(AddColor.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the color 😣")

      state.colorAddLoading = false
      state.colorAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const colorUpdateSlice = createSlice({
  name: "colorUpdate",
  initialState: {
    colorUpdate: {},
    colorUpdateLoading: false,
    colorUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateColor.pending, (state) => {
      // toast.loading('We are updating the color 🤯')
      state.colorUpdateLoading = true
    });

    builder.addCase(UpdateColor.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.colorUpdate = action.payload
      state.colorUpdateLoading = false
      state.colorUpdateError = null
    });

    builder.addCase(UpdateColor.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the color 😣")

      state.colorUpdateLoading = false
      state.colorUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const colorListSlice = createSlice({
  name: "colorList",
  initialState: {
    colorList: [],
    colorListLoading: false,
    colorListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetColorList.pending, (state) => {
      state.colorListLoading = true
    });

    builder.addCase(GetColorList.fulfilled, (state, action) => {
      toast.dismiss();

      state.colorList = action.payload
      state.colorListLoading = false
      state.colorListError = null
    });

    builder.addCase(GetColorList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the color 😣")

      state.colorListLoading = false
      state.colorListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});